import React,{useEffect} from 'react';
import {getVersionDetails} from '../function_lib/common_lib';
export const Comp_Member_Quick_Activity=(props)=>{
  useEffect(()=>{
//alert("i m in data"+JSON.stringify(props.dashboardData));
  },[props.dashboardData])
return(<div class="card">
    <div class="card-header">
      <h5 class="card-title">Welcome : <b>{props.userObject[0]["first_name"]}</b></h5>
      
      <div class="card-tools">
        
        <button type="button" class="btn btn-tool" data-bs-target="#bdy_mem_quick_access" data-bs-toggle="collapse" data-card-widget="collapse">
          <i class="fa fa-minus"></i>
        </button>
        <div class="btn-group">
          <a href="../cadet_data_sync" class="button btn btn-danger">Check Data Sync</a>
          {/* <button type='button'>Check for Data Sync</button> */}
          <button type="button" class="btn btn-tool dropdown-toggle" data-bs-toggle="dropdown" data-toggle="dropdown">
            <i class="fa fa-wrench"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right" role="menu">
            <a href="#" class="dropdown-item">Action</a>
            <a href="#" class="dropdown-item">Another action</a>
            <a href="#" class="dropdown-item">Something else here</a>
            <a class="dropdown-divider"></a>
            <a href="#" class="dropdown-item">Separated link</a>
          </div>
        </div>
        <button type="button" class="btn btn-tool" data-card-widget="remove">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    
    <div class="card-body" id="bdy_mem_quick_access">
    {/* <!-- Info boxes --> */}
        <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
                <table>
                  <tr>
                    <td>
                    <h6 className='float-right11'>Verions: {getVersionDetails()} </h6>
                    </td>
                  </tr>
                    <tr>
                        <td><a href={"javascript:void(0)"} data-bs-toggle="modal" data-bs-target="#divCRBIntoduction" data-toggle="modal" data-target="#divCRBIntoduction"><h6>Introduction & Completion Guidelines</h6></a></td>
                    </tr>
                    <tr>
                        <td><a href={"javascript:void(0)"} data-bs-toggle="modal" data-bs-target="#divCRBRolesResp" data-toggle="modal" data-target="#divCRBRolesResp"><h6>Roles and responsibilities</h6></a></td>
                    </tr>
                    <tr>
                        <td><a href={"javascript:void(0)"} data-bs-toggle="modal" data-bs-target="#divCRBEducationalRec" data-toggle="modal" data-target="#divCRBEducationalRec"><h6>Cadet educational record</h6></a></td>
                    </tr>
                    </table>

            </div>
          <div class="col-12 col-sm-6 col-md-3">

            <a class="info-box" href="../task_list">
              <span class="info-box-icon bg-info11 elevation-1 sem3"><i class="fa fa-tasks white"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Semester 3</span>
                <span class="info-box-number">
                  {props.dashboardData?.sem["Semester3"]}
                  <small> Tasks</small>
                </span>
              </div>
            </a>
          </div>
          

          <div class="col-12 col-sm-6 col-md-3">
            <a class="info-box mb-3 " href="../task_list">
           
              <span class="info-box-icon bg-danger11 elevation-1 sem4"><i class="fa fa-tasks white"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Semester 4</span>
                <span class="info-box-number"> {props.dashboardData?.sem["Semester4"]}
                <small> Tasks</small>
                </span>
              </div>
            
            </a>
          </div>
         

          
          {/* <div class="clearfix hidden-md-up"></div> */}

          <div class="col-12 col-sm-6 col-md-3">
          <a class="info-box mb-3" href="../task_list">
            
              <span class="info-box-icon bg-success11 elevation-1 sem5"><i class="fa fa-tasks white"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Semester 5</span>
                <span class="info-box-number"> {props.dashboardData?.sem["Semester5"]}
                <small> Tasks</small>
                </span>
              </div>
            
            </a>
          </div>
          
        

        </div>
{/* end of quic activity */}

      
    </div>
    
    {/* <div class="card-footer">
      <div class="row">
      </div>
      
    </div> */}
    
  </div>)
}

export default Comp_Member_Quick_Activity;